import { createRouter, createWebHistory } from '@ionic/vue-router';
import Login from "../pages/account/login.vue";
import EditProfile from "../pages/account/edit-profile.vue";
import Dashboard from "../pages/account/dashboard.vue";
import PageInbox from "../pages/PageInbox.vue";
import Customers from "../pages/customers/index.vue";
import CustomerSegments from "../pages/customers/segments.vue";
import BroadcastWhatsapp from "../pages/broadcast/index.vue";
import SalesChannelSMS from "../pages/sales-channel/sms/index.vue";
import SalesChannelSMSComplianceKeywords from "../pages/sales-channel/sms/sms-compliance-keywords.vue";
import SalesChannelEmail from "../pages/sales-channel/email/index.vue"; // TODO: re-enable with route
import SalesChannelWhatsapp from "../pages/sales-channel/whatsapp/index.vue";
import SalesChannelWhatsappWidget from "../pages/sales-channel/whatsapp/widget.vue";
import SalesChannelWhatsappMessageTemplates from "../pages/sales-channel/whatsapp/message-templates.vue";
import SalesChannelWhatsappAddTemplate from "../pages/sales-channel/whatsapp/add-template.vue";
import SalesChannelWhatsappComplianceKeywords from "../pages/sales-channel/whatsapp/whatsapp-compliance-keywords.vue";
import SalesChannelGoogleRCS from "../pages/sales-channel/googleRCS/index.vue";
import SalesChannelGoogleRCSComplianceKeywords from "../pages/sales-channel/googleRCS/googlercs-compliance-keywords.vue";
import ConnectorLayout from "../pages/integrations/index.vue";
import IntegrationsList from "../pages/integrations/integrations-list.vue";
import MoEngageIntegrate from "../pages/integrations/moengage-settings.vue";
import SFMCSettings from "../pages/integrations/sfmc-settings.vue";
import Settings from "../pages/settings/index.vue";
import LiveChatSettings from "../pages/settings/live-chat.vue";
import ManageTeam from "../pages/settings/team/index.vue";
import AddMember from "../pages/settings/team/add-member.vue";
import AddGroup from "../pages/settings/team/add-group.vue";
import PasswordSettings from "../pages/settings/password.vue";
import DataPrivacy from "../pages/settings/data-privacy.vue";
import SsoSettings from "../pages/settings/sso-settings.vue";
import BusinessAccountSettings from "../pages/settings/account.vue";
import NotFound from "../pages/NotFound.vue";
import Test from "../pages/Test.vue";
import ApplicationsList from "../pages/developer-portal/applications/apps-list.vue";
import CreateApplication from "../pages/developer-portal/applications/create-app.vue";
import ViewApplication from "../pages/developer-portal/applications/view-app-details.vue";
import ApiReference from "../pages/developer-portal/apiReference/api-reference.vue";
import { useAuthStore } from '../stores/auth';
import DeveloperPortalAnalytics from "../pages/developer-portal/analytics/Analytics.vue";
import DeveloperPortalSettings from "../pages/developer-portal/settings/Settings.vue";
import { canAccessRoute } from '@/shared/access-control';

const routes = [
  {
    path: "/",
    redirect: "/login"
  },
  {
    path: "/login",
    component: Login
  },
  {
    path: "/account/edit-profile", //open for all
    component: EditProfile
  },
  {
    path: "/test", //open for all
    component: Test
  },
  {
    path: "/dashboard", //open for all
    component: Dashboard
  },
  {
    path: "/page-inbox",
    component: PageInbox,
    meta: { permissionKey: 'livechat' }
  },
  {
    path: "/customers",
    component: Customers,
    meta: { permissionKey: 'manageCustomers' }
  },
  {
    path: "/customers/segments",
    component: CustomerSegments,
    meta: { permissionKey: 'segments' }
  },
  {
    path: "/settings", //open for all
    component: Settings
  },
  {
    path: "/settings/live-chat",
    component: LiveChatSettings,
    meta: { permissionKey: 'liveChatSettings' }, //only for admins
  },
  {
    path: "/settings/password",
    component: PasswordSettings,
    meta: { permissionKey: 'admin', ssoRestricted: true }, //only for admins
  },
  {
    path: "/settings/data-privacy",
    component: DataPrivacy,
    meta: { permissionKey: 'dataPrivacy' }, //only for admins
  },
  {
    path: "/settings/sso",
    component: SsoSettings,
    meta: { permissionKey: 'addons.sso', ownerOnly: true }
  },
  {
    path: "/settings/team",
    component: ManageTeam,
    meta: { permissionKey: 'manageTeamMembers' }, //only for admins
  },
  {
    path: "/settings/team/add-member",
    component: AddMember,
    meta: { permissionKey: 'manageTeamMembers' }, //only for admins
  },
  {
    path: "/settings/team/add-group",
    component: AddGroup,
    meta: { permissionKey: 'manageTeamMembers' }, //only for admins
  },
  {
    path: "/settings/account",
    component: BusinessAccountSettings,
    meta: { permissionKey: 'admin' },
  },
  {
    path: "/broadcast",
    component: BroadcastWhatsapp,
    meta: { permissionKey: 'broadcast' }
  },
  {
    path: "/sales-channel/sms",
    component: SalesChannelSMS,
    meta: { permissionKey: 'vonagesms' }
  },
  {
    path: "/sales-channel/sms/compliance-keywords",
    component: SalesChannelSMSComplianceKeywords,
    meta: { permissionKey: 'vonagesms' }
  },
  {
    path: "/sales-channel/email",
    component: SalesChannelEmail,
    meta: { permissionKey: 'vonageemail' }
  },
  {
    path: "/sales-channel/whatsapp",
    component: SalesChannelWhatsapp,
    meta: { permissionKey: 'whatsapp' }
  },
  {
    path: "/sales-channel/whatsapp/widget",
    component: SalesChannelWhatsappWidget,
    meta: { permissionKey: 'whatsapp' }
  },
  {
    path: "/sales-channel/whatsapp/message-templates",
    component: SalesChannelWhatsappMessageTemplates,
    meta: { permissionKey: 'whatsapp' }
  },
  {
    path: "/sales-channel/whatsapp/add-template",
    component: SalesChannelWhatsappAddTemplate,
    meta: { permissionKey: 'whatsapp' }
  },
  {
    path: "/sales-channel/whatsapp/add-template/:id",
    component: SalesChannelWhatsappAddTemplate,
    meta: { permissionKey: 'whatsapp' }
  },
  {
    path: "/sales-channel/whatsapp/compliance-keywords",
    component: SalesChannelWhatsappComplianceKeywords,
    meta: { permissionKey: 'whatsapp' }
  },
  {
    path: "/sales-channel/google-rcs",
    component: SalesChannelGoogleRCS,
    meta: { permissionKey: 'googlercs' }
  },
  {
    path: "/sales-channel/google-rcs/compliance-keywords",
    component: SalesChannelGoogleRCSComplianceKeywords,
    meta: { permissionKey: 'googlercs' }
  },
  {
    path: "/integrations",
    component: ConnectorLayout, // 👈 wrapper/layout component
    children: [
      { path: '', component: IntegrationsList },
      { path: 'moengage', component: MoEngageIntegrate },
      { path: 'sfmc', component: SFMCSettings },
    ],
    meta: { permissionKey: 'addons.moengage||addons.sfmc' }
  },
  {
    path: "/bot-builder",
    component: () => import('@/pages/bot-builder/index.vue'),
    meta: { permissionKey: 'botBuilder' }
  },
  {
    path: "/bot-builder/create",
    component: () => import('@/pages/bot-builder/create/index.vue'),
    meta: { permissionKey: 'botBuilder' }
  },
  {
    path: "/bot-builder/create/:id",
    component: () => import('@/pages/bot-builder/create/id.vue'),
    meta: { permissionKey: 'botBuilder' }
  },
  {
    path: "/analytics/broadcast-legacy",
    component: () => import('@/pages/analytics/broadcast.vue'),
    meta: { requiredAuth: true, permissionKey: 'broadcast', oldPermKey: 'analytics' }
  },
  {
    path: "/analytics/broadcast",
    component: () => import('@/pages/analytics/broadcast-v2/index.vue'),
    meta: { requiredAuth: true, permissionKey: 'broadcast', oldPermKey: 'analytics' }
  },
  {
    path: "/analytics/livechat",
    component: () => import('@/pages/analytics/livechat.vue'),
    meta: { permissionKey: 'livechat' }
  },
  {
    path: "/analytics/customers-legacy",
    component: () => import('@/pages/analytics/customers.vue'), //only for admins
    meta: { permissionKey: 'customers' }
  },
  {
    path: "/analytics/customers",
    component: () => import('@/pages/analytics/customers-v2/index.vue'), //only for admins
    meta: { permissionKey: 'customers' }
  },
  /* {
    path: "/analytics/referral",
    component: () => import('@/pages/analytics/referral/index.vue'),
    meta: { requiredAuth: true, oldPermKey: 'analytics' }
  },
  {
    path: "/analytics/rcs",
    component: () => import('@/pages/analytics/rcs_analytics/rcs_analytics.vue'),
    meta: { permissionKey: 'googlercs' }
  },
  {
    path: "/analytics/engagement",
    component: () => import('@/pages/analytics/engagement.vue'), //only for admins
    meta: { permissionKey: 'engagement' }
  }, */
  {
    path: "/developer-portal/applications",
    component: ApplicationsList,
    meta: { permissionKey: 'developerPortal', adminOnly: true },
  },
  {
    path: "/developer-portal/api-reference",
    component: ApiReference,
    meta: { permissionKey: 'developerPortal', adminOnly: true },
  },
  {
    path: "/developer-portal/applications/create",
    component: CreateApplication,
    meta: { permissionKey: 'developerPortal', adminOnly: true },
  },
  {
    path: "/developer-portal/applications/:id",
    component: ViewApplication,
    meta: { permissionKey: 'developerPortal', adminOnly: true },
  },
  {
    path: "/developer-portal/analytics",
    component: DeveloperPortalAnalytics,
    meta: { permissionKey: 'developerPortal', adminOnly: true },
  },
  {
    path: "/developer-portal/settings",
    component: DeveloperPortalSettings,
    meta: { permissionKey: 'developerPortal', adminOnly: true },
  },
  {
    path: "/404",
    component: NotFound,
    meta: { requiredAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

function guard(to, from, loginStatus) {
  if(['/login'].includes(to.path)) return true;
  if(loginStatus !== 'success') return { path: "/login" };
  if(checkPermission(to)) return true;
  return { path: "/404" };
}

function checkPermission(to) {
  return canAccessRoute(to, useAuthStore());
}

router.beforeEach(async (to, from) => {
  const authStore = useAuthStore();
  const loginStatus = authStore.getLoginStatus;
  if (loginStatus === 'pending') {
    await authStore.loadStorageTokens();
    const newLoginStatus = authStore.getLoginStatus;
    return guard(to, from, newLoginStatus);
  } else {
    return guard(to, from, loginStatus);
  }
});

export default router
